module.exports = __webpack_public_path__ + "img/SK30844789.ee0f6843.png";